import * as yup from 'yup';
import { MessageConstant } from '../MessageConstant';

const message = MessageConstant.common;

export const billToCompanyValidation: { [x: string]: any; } = {
  billToCompany: yup.string().required(message.MISSING),
};
export const updateBillToCompanyValidation: { [x: string]: any; } = {
  ...billToCompanyValidation,
};

export const chargeOnCompanyValidation: { [x: string]: any; } = {
  chargeOnCompany: yup.string().required(message.MISSING),
};
export const updateChargeOnCompanyValidation: { [x: string]: any; } = {
  ...chargeOnCompanyValidation,
};

export const updateBillToCompanyValidationSchema = yup.object().shape(updateBillToCompanyValidation);
export const updateChargeOnCompanyValidationSchema = yup.object().shape(updateChargeOnCompanyValidation);

